import { init } from "next-firebase-auth";
import logger from "./logger";

const firebaseClientInitConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  // measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};
const firebaseAdminInitConfig = {
  credential: {
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    clientEmail: process.env.FIREBASE_CLIENT_EMAIL,
    // The private key must not be accessible on the client side.
    privateKey: process.env.FIREBASE_PRIVATE_KEY,
  },
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
};

const initAuth = () => {
  init({
    authPageURL: ({ ctx }) => {
      if (ctx?.locale) return `/${ctx?.locale}/users/login`;
      return "/users/login";
    },
    appPageURL: ({ ctx }) => {
      if (ctx?.locale) return `/${ctx?.locale}`;
      return "/";
    },
    loginAPIEndpoint: "/api/session", // required
    logoutAPIEndpoint: "/api/logout", // required
    onLoginRequestError: (err) => {
      logger.error(err);
    },
    onLogoutRequestError: (err) => {
      logger.error(err);
    },
    // firebaseAuthEmulatorHost: 'localhost:9099',
    firebaseAdminInitConfig: firebaseAdminInitConfig as any,
    // Use application default credentials (takes precedence over fireaseAdminInitConfig if set)
    // useFirebaseAdminDefaultCredential: true,
    firebaseClientInitConfig: firebaseClientInitConfig as any,
    cookies: {
      name: "playwhat", // required
      // Keys are required unless you set `signed` to `false`.
      // The keys cannot be accessible on the client side.
      keys: [
        process.env.AUTH_COOKIE_SECRET_CURRENT,
        process.env.AUTH_COOKIE_SECRET_PREVIOUS,
      ],
      httpOnly: true,
      maxAge: 12 * 60 * 60 * 24 * 1000, // twelve days
      overwrite: true,
      path: "/",
      sameSite: "strict",
      secure: true, // set this to false in local (non-HTTPS) development
      signed: true,
    },
    onVerifyTokenError: (err) => {
      logger.error(err);
    },
    onTokenRefreshError: (err) => {
      logger.error(err);
    },
  });
};

export default initAuth;
